/**
 * @typedef {import('../types/ringba-accounts').RingbaAccounts.RingbaAccount} RingbaAccount
 * @typedef {import('../types/ringba-accounts').RingbaAccounts.ListAccountsResponse} ListAccountsResponse
 */

import httpClient from './httpClient'

const END_POINT = '/customerresources/user-account'

const RingbaAccountsAPI = {

  /**
   * Get all Ringba accounts for a RingbaX account
   * @param {string} accountId - The RingbaX account ID
   * @returns {Promise<ListAccountsResponse>} Promise resolving to array of Ringba accounts
   */
  async listAccounts(accountId) {
    return await httpClient.get(`${END_POINT}/${accountId}/ringba-accounts`)
  },

  /**
   * Set the Ringba account for a RingbaX account
   * @param {string} accountId - The RingbaX account ID
   * @param {string} ringbaAccountId - The Ringba account ID to set
   * @returns {Promise} Promise resolving when the account is set
   */
  async setRingbaAccount(accountId, ringbaAccountId) {
    return await httpClient.patch(`${END_POINT}/${accountId}/ringba-account`, {
      RingbaAccountId: ringbaAccountId
    })
  }
}

export default RingbaAccountsAPI